import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseService } from '@core/services/core/base.service';
import { HealthAppLoginRawResponse, HealthAppLoginResponse } from '@models/health-app';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class HealthAppService {

  constructor(
    private http: HttpClient,
    private base: BaseService,
  ) { }

  private mapLogin(response: HttpResponse<HealthAppLoginRawResponse>): HealthAppLoginResponse {
    return {
      body: response?.body?.client,
      jwtAccessToken: response?.body?.token,
      nuuma: response?.body?.nuuma
    } as HealthAppLoginResponse;
  }

  getHealthAppLoginCredentials(documentNumber: string) {
    const url = `${this.base.getPrivateOIMBaseUrl()}/salud/login?documentNumber=${documentNumber}`;
    const headers = this.base.getLoginHeaders()

    return this.http
    .get(url, { headers, observe: 'response' })
    .pipe(map((response: HttpResponse<HealthAppLoginRawResponse>) => this.mapLogin(response)));
  }

}
